$(function () {
  $('a[title]').tooltip({placement:'top'});
  $('img[title]').tooltip({placement:'bottom'});
  $('[data-scroll]').click(function(e){
	var target = $('#'+$(this).data('scroll'));
	if( !target.length ) return;
	target.addClass('sub');
	setTimeout(function(){
		target.removeClass('sub');
	}, 5000);
	$('body').animate({ scrollTop: target.offset().top - $(window).height()*0.2 }, 500);
  });
  var imgs = $('img[data-src]');
  var igbase = $('meta[name=igbase]').attr('content');
  for(var i=0,l=imgs.length;i<l;i++){
	  var im = imgs.eq(i),src=im.data('src');im.removeAttr('data-src');
	  im.attr('src', '//'+igbase+'/g/'+src.substr(0,2)+'/'+src+'.png');
  };
  var imgspan = $('span[data-src]');
  for(var i=0,l=imgspan.length;i<l;i++){
	  var im = imgspan.eq(i),src=im.data('src');im.removeAttr('data-src');
	  im.css('background-image', 'url(//'+igbase+'/g/'+src.substr(0,2)+'/'+src+'.png)');
  };
  
  $('table>tbody[id]').each(function(){
	  tbody = $(this);
	  var ip = tbody.find('input[type=number]');
	  var dataSet = tbody.find('[data-set]');
	  var result = tbody.find('span.slot-result');
	  var origin = dataSet.map(function(){
		  var el = $(this),set = Math.max(el.data('set')|0,1),unit = Math.max(el.text()|0,1);
		  return {set:set,unit:unit,el:el};
	  });
	  ip.on('input', function(e,init){
		  var count = $(this).val()|0,init=init||false,slot = 0;
		  if( count <= 0 ) return;
		  origin.each(function(i,set){
			  var t=set.unit*count,m=t%set.set,s = t/set.set|0;
			  slot += Math.ceil(t/set.set);
			  if(!init) {
				  var p = [];
				  if( s >= 1 ) {
						  p.push(s+' 組');
					  if( m >= 1 ) {
						  if(p.length) p.push(' +');
						  p.push(' '+m);
					  }
					  p.push(' = '+t);
				  } else p.push(t);
				  set.el.text(p.join(''));
			  }
		  });
		  result.text(slot);
	  }).trigger('input',[true]);
  });
});